import { Injectable } from "@angular/core";

import { Observable, of } from "rxjs";

import { BaseSearchResultsModel } from "../../../models/base-search-results.model";

import { MarketplaceItemModel } from "../models/marketplace-item.model";
import { MarketplaceSearchParametersModel } from "../models/marketplace-search-parameters.model";
import { catchError } from "rxjs/operators";
import { ApiRequestDispatcherService } from "../../../api/api-request-dispatcher.service";

@Injectable({
    providedIn: "root"
})
export class MarketplaceSearchService {
    private readonly API_GET_LIST_URL = "/api/s4s-advanced-search/marketplace-search/get-list";

    public constructor(private _requestDispatcher: ApiRequestDispatcherService) {}

    public getSearchResults(searchParams: MarketplaceSearchParametersModel): Observable<BaseSearchResultsModel<MarketplaceItemModel>> {
        return this._requestDispatcher.get<BaseSearchResultsModel<MarketplaceItemModel>>(this.API_GET_LIST_URL, { searchParams: JSON.stringify(searchParams) }).pipe(
            catchError((error) => {
                console.error(error);
                return of({ pageNumber: 1, pageSize: searchParams.pageSize, totalPages: 0, totalItems: 0, pageItems: [], recommendedLinks: [] });
            })
        );
    }
}
